import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
const forYou = ['People with chronic, recurring symptoms that "doctors can\'t explain."', 'Individuals suffering from autoimmune issues, digestive distress, or chronic fatigue.', 'Anyone who feels "stuck" in a cycle of physical pain despite trying everything.', 'Seekers who believe that the mind and body are profoundly interconnected.'];
const notForYou = ['People looking for a "magic pill" without doing the inner reflection.', 'Those who refuse to believe emotions can impact physical health.', 'Anyone currently in a life-threatening medical emergency (seek a hospital immediately).'];
export function WhoThisIsFor() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-navy py-20 px-6 md:px-12" data-id="element-139">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.8
    }} className="max-w-6xl mx-auto space-y-12" data-id="element-140">
        <h2 className="text-3xl md:text-5xl font-bold text-white text-center" data-id="element-141">
          Is This For You?
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-142">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: -20
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-dark-navy-light p-8 rounded-lg space-y-6" data-id="element-143">
            <h3 className="text-2xl font-bold text-teal-accent flex items-center gap-3" data-id="element-144">
              <CheckCircleIcon className="w-8 h-8" data-id="element-145" />
              This is for you if...
            </h3>
            <ul className="space-y-4" data-id="element-146">
              {forYou.map((item, index) => <li key={index} className="flex gap-3 items-start" data-id="element-147">
                  <CheckCircleIcon className="w-5 h-5 text-teal-accent flex-shrink-0 mt-1" data-id="element-148" />
                  <span className="text-stone-300 leading-relaxed" data-id="element-149">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: 20
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-dark-navy-light p-8 rounded-lg space-y-6" data-id="element-150">
            <h3 className="text-2xl font-bold text-red-400 flex items-center gap-3" data-id="element-151">
              <XCircleIcon className="w-8 h-8" data-id="element-152" />
              This is NOT for you if...
            </h3>
            <ul className="space-y-4" data-id="element-153">
              {notForYou.map((item, index) => <li key={index} className="flex gap-3 items-start" data-id="element-154">
                  <XCircleIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-155" />
                  <span className="text-stone-300 leading-relaxed" data-id="element-156">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </motion.div>
    </section>;
}